import {useState} from "react";

interface Args{
    totalElements?: number;
}
export const useConsultationPagination = ({totalElements}:Args) => {
    const ITEMS_PER_PAGE =  4;
    const [currentPage, setCurrentPage] = useState(0);
    const totalPages = Math.ceil((totalElements ?? 0) / ITEMS_PER_PAGE);

    const paginationRange = 5;
    const startPage = Math.max(0, Math.min(currentPage - Math.floor(paginationRange / 2), totalPages - paginationRange));
    const endPage = Math.min(totalPages, startPage + paginationRange);

    const handlePageChange = (page: number) => {
        if (page >= 0 && page < totalPages) {
            setCurrentPage(page);
        }
    };

    return { currentPage, startPage, endPage, handlePageChange };
};
